/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export default function trackByIndex(index: number, element: any): number {
    return index;
}
